import { IRootState } from '../reducer'
import { prefix } from './actions'

export const socketStatus = (state: IRootState) => state[prefix].socketStatus
